import { useQuery } from "@tanstack/react-query";
import { fetchProfileWizardStatus } from "@/api/profiles";
import { queryKeys } from "@/lib/queryKeys";

export const useWizardCompleted = (userId: string | null | undefined) => {
  const { data: isWizardComplete = false, isLoading, isError } = useQuery({
    queryKey: queryKeys.wizardCompleted.detail(userId ?? null),
    queryFn: async (): Promise<boolean> => {
      // Propager l'erreur : sinon un échec réseau serait mis en cache comme
      // « wizard non terminé » (staleTime Infinity) et la garde
      // RequireWizardCompleted forcerait un utilisateur existant vers
      // l'onboarding en boucle.
      const { data, error } = await fetchProfileWizardStatus(userId!);
      if (error) throw error;
      return !!(data as { wizard_completed_at: string | null } | null)?.wizard_completed_at;
    },
    enabled: !!userId,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  return { isWizardComplete, isLoading, isError };
};
